import moment from "moment";

const formatYmd = (date:any) => date.toISOString().slice(0, 10);

export let today = formatYmd(new Date());

export let year = new Date().getFullYear();

export let todayDateWithTime = moment(new Date()).format("DD/MM/YYYY hh:mm:ss");
export let displayValue = (value: any) => ((value === null||value===""||value===undefined) ? '-' : value);//apiden dönen veriler null ise '-' olarak gösterir
export function formatTurkishToEnglishString(title:any) {


    // Türkçe karakterleri İngilizce karşılıklarına çevirme
    const turkishChars:any = {
      'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u',
      'Ç': 'C', 'Ğ': 'G', 'İ': 'I', 'Ö': 'O', 'Ş': 'S', 'Ü': 'U'
    };
  
    const formattedTitle = title
      .split('')
      .map((char:any) => turkishChars[char] || char)  // Türkçe karakterleri değiştir
      .join('')
      .toLowerCase()                            // Küçük harfe çevir
      .replace(/ /g, '-')                       // Boşlukları '-' ile değiştir
      .replace(/[^a-z0-9-]/g, '');              // Harf ve rakam olmayan karakterleri kaldır
  
    return formattedTitle;
  }
  export const filterOptions = (options: any, { inputValue }: any, getOptionLabel: (option: any) => string) => {
    return options.filter((option: any) =>
      getOptionLabel(option)?.toLowerCase().includes(inputValue.toLowerCase())
    );
  };